import { render, staticRenderFns } from "./UpdateVpdn.vue?vue&type=template&id=1c3fb101&"
import script from "./UpdateVpdn.vue?vue&type=script&lang=js&"
export * from "./UpdateVpdn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports